import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  IndustryAndPrimaryActivityStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';
import { IndustryOptions } from 'app/features/profile/businessDetails/addBusinessDetails/formFields';

export const fields: IBaseField<keyof IndustryAndPrimaryActivityStateValues>[] =
  [
    {
      name: 'businessIndustry',
      label: 'Business Industry',
      type: 'select',
      options: [...IndustryOptions],
      effect: updateKeyInStore(updateKey),
      tooltip: '',
      comment: true,
    },
    {
      name: 'description',
      label: 'Description',
      type: 'text',
      effect: updateKeyInStore(updateKey),
      tooltip: '',
      comment: true,
    },
  ];

export const validationSchema = Yup.object().shape({
  businessIndustry: Yup.string().nullable().required('Reqruied'),
});
